<template>
    <brick-octagon-base>
        <div class="brick-title">
            {{displayName}}
        </div>
    </brick-octagon-base>
</template>

<script>
    import permissionsMixin from '../../Mixins/journey-permissions';

    import BrickOctagonBase from "./../BrickOctagonBase.vue";

    export default {
        name: 'composable-octagon-brick',
        components: {
            BrickOctagonBase
        },
        mixins: [permissionsMixin],
        props: {
            displayName: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped src="../../Style/composable-octagon-brick.scss" lang="scss" />
